import { Button, Card, Typography } from 'antd';
import { ChevronDown } from 'assets/svg';
import { I18nContext } from 'contexts/I18n/I18nProvider';
import NoRecordsComponent from 'core/no-records/no-records-container';
import { TimelineItem } from 'modules/operational/device/detail/dvr/redux/types';
import { NpvrState } from 'modules/operational/npvr/redux/types';
import { useContext, useEffect, useState } from 'react';
import TimelineComponent from './timeline-component';

type TimelineProps = {
  npvr: NpvrState
  hhid: string
}

export default function Timeline({ npvr, hhid }: TimelineProps) {
  const t = useContext(I18nContext)
  const [isToShowTimeline, setIsToShowTimeline] = useState(false)

  const handleTimelineOnClick = () => {
    setIsToShowTimeline(!isToShowTimeline)
  }

  useEffect(() => {
      setIsToShowTimeline(false)
    }, [hhid])

  const hasTimelineItems =
    npvr.timelineItems && npvr.timelineItems.some((item: TimelineItem) => item.status.length !== 0);

  return (
    <div className="features-card">
      <Card className="card-is-relative">       
      <Typography.Title style={{marginTop: "0.5rem"}} level={5}>{t('dvr.label_timeline_title')}</Typography.Title>
      <Button 
        className='chevron-button'
        type={"primary"}
        shape={"circle"}  
        size={"small"}
        onClick={handleTimelineOnClick} 
        icon={
          <ChevronDown className={`icon has-padding-xs icon-white icon-svg icon-xx-small
            ${isToShowTimeline ? 'icon-180' : ''}`}/>}
      />
      <div className={`timeline-container-outer timeline-transition ${isToShowTimeline ? 'timeline-expanded' : 'timeline-collapsed'}`}>
        {npvr.timelineItems && hasTimelineItems ? (
          <TimelineComponent timelineData={npvr.timelineItems} />
        ) : (
          <NoRecordsComponent />
        )}
      </div>
      </Card> 
    </div>
  )
}
